<template>
    <div class="space-y-6">
        <!-- 网站标题设置 -->
        <div class="card bg-base-100 shadow-lg border border-base-200">
            <div class="card-body">
                <h2 class="card-title text-lg font-semibold mb-4 flex items-center">
                    <svg class="w-5 h-5 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                            d="M7 8h10M7 12h4m1 8l-4-4H5a2 2 0 01-2-2V6a2 2 0 012-2h14a2 2 0 012 2v8a2 2 0 01-2 2h-3l-4 4z">
                        </path>
                    </svg>
                    网站标题设置
                </h2>

                <div class="space-y-4">
                    <div class="form-control w-full max-w-md">
                        <label class="label">
                            <span class="label-text font-medium">网站标题</span>
                        </label>
                        <input type="text" placeholder="请输入网站标题" v-model="formData.site_title"
                            @change="updateSys('site_title')" class="input input-bordered focus:input-primary" />
                        <label class="label">
                            <span class="label-text-alt text-base-content/70">自定义网站标题，将显示在页面顶部导航栏</span>
                        </label>
                    </div>

                    <div class="form-control">
                        <label class="label cursor-pointer justify-start gap-4">
                            <span class="label-text font-medium">显示版本标识</span>
                            <input type="checkbox" class="toggle toggle-primary toggle-lg"
                                v-model="formData.show_role_badge" @change="updateSys('show_role_badge')" />
                        </label>
                        <label class="label">
                            <span class="label-text-alt text-base-content/70">控制是否在页面顶部显示版本标识（V1/V2）</span>
                        </label>
                    </div>
                </div>
            </div>
        </div>

        <div class="card bg-base-100 shadow-lg border border-base-200">
            <div class="card-body">
                <h2 class="card-title text-lg font-semibold mb-4 flex items-center">
                    <svg class="w-5 h-5 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                            d="M12 6v6l4 2M19 6a7 7 0 11-14 0 7 7 0 0114 0z" />
                    </svg>
                    主题配色
                </h2>
                <div class="text-sm text-base-content/70 mb-4">当前主题：{{ currentTheme }}</div>
                <div class="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-3 gap-4">
                    <div v-for="theme in themes" :key="theme"
                        class="border-base-content/20 hover:border-base-content/40 overflow-hidden rounded-lg border outline outline-2 outline-offset-2 transition"
                        :class="currentTheme === theme ? '!outline-base-content' : 'outline-transparent'"
                        :data-set-theme="theme" data-act-class="!outline-base-content" @click="switchTheme(theme)">
                        <div :data-theme="theme" class="bg-base-100 text-base-content w-full cursor-pointer font-sans">
                            <div class="grid grid-cols-5 grid-rows-3">
                                <div class="bg-base-200 col-start-1 row-span-2 row-start-1"></div>
                                <div class="bg-base-300 col-start-1 row-start-3"></div>
                                <div
                                    class="bg-base-100 col-span-4 col-start-2 row-span-3 row-start-1 flex flex-col gap-1 p-2">
                                    <div class="font-bold">{{ theme }}</div>
                                    <div class="flex flex-wrap gap-1">
                                        <div class="bg-primary flex aspect-square w-5 items-center justify-center rounded lg:w-6">
                                            <div class="text-primary-content text-sm font-bold">A</div>
                                        </div>
                                        <div class="bg-secondary flex aspect-square w-5 items-center justify-center rounded lg:w-6">
                                            <div class="text-secondary-content text-sm font-bold">A</div>
                                        </div>
                                        <div class="bg-accent flex aspect-square w-5 items-center justify-center rounded lg:w-6">
                                            <div class="text-accent-content text-sm font-bold">A</div>
                                        </div>
                                        <div class="bg-neutral flex aspect-square w-5 items-center justify-center rounded lg:w-6">
                                            <div class="text-neutral-content text-sm font-bold">A</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="card bg-base-100 shadow-lg border border-base-200">
            <div class="card-body">
                <h2 class="card-title text-lg font-semibold mb-4 flex items-center">
                    <svg class="w-5 h-5 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                            d="M3 5a2 2 0 012-2h14a2 2 0 012 2v14a2 2 0 01-2 2H5a2 2 0 01-2-2V5zm3 12l3-4 2 3 3-4 4 5" />
                    </svg>
                    背景设置
                </h2>

                <div class="grid grid-cols-1 gap-4">
                    <div>
                        <div class="text-sm font-medium mb-2">隐藏背景图</div>
                        <input type="checkbox" class="toggle" v-model="isHiddenBGP" />
                    </div>
                    <div>
                        <div class="text-sm font-medium mb-2">自定义背景图</div>
                        <div class="flex flex-col gap-2">
                            <div class="flex items-center gap-2 flex-wrap">
                                <input type="file" class="file-input file-input-sm file-input-bordered w-full max-w-xs"
                                    accept="image/*" @change="handleBackgroundUpload" ref="backgroundInput" />
                                <button class="btn btn-sm" @click="clearBackground">清除</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { THEME_LIST, THEME_COLOR_MAP } from '@/utils/themeConfig'
import { initTheme, switchTheme } from '@/utils/themeUtils'

export default {
    name: 'PersonalizationSettings',
    props: {
        formData: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
            currentTheme: 'light',
            themes: THEME_LIST,
            colorMap: THEME_COLOR_MAP,
        }
    },
    computed: {
        ...mapGetters(['getUsername', 'getIsSuperuser']),
        isHiddenBGP: {
            get() {
                return window.localStorage.getItem('isHiddenBGP') === 'true'
            },
            set(value) {
                window.localStorage.setItem('isHiddenBGP', value ? 'true' : 'false')
            }
        }
    },
    created() {
        this.initTheme()
    },
    methods: {
        updateSys(key) {
            this.$emit('update-sys', key)
        },
        initTheme() {
            this.currentTheme = initTheme(this.currentTheme, this.colorMap)
        },
        switchTheme(theme) {
            this.currentTheme = switchTheme(theme, this.colorMap)
        },
        handleBackgroundUpload(event) {
            const file = event.target.files[0]
            if (file) {
                const formData = new FormData()
                formData.append('upload_file', file)

                this.$api.Task.uploadImageAndSave(formData).then((res) => {
                    if (res.result) {
                        this.$myMsg.notify({
                            title: '上传成功！',
                            content: '图片已保存到本地',
                            type: 'success',
                            time: 3000,
                        })
                    } else {
                        this.$myMsg.notify({
                            title: '上传失败！',
                            content: res.message,
                            type: 'error',
                            time: 3000,
                        })
                    }
                }).catch(error => {
                    this.$myMsg.notify({
                        title: '上传失败！',
                        content: error.message,
                        type: 'error',
                        time: 3000,
                    })
                })
            }
        },
        clearBackground() {
            this.$api.Task.restoreLogo().then((res) => {
                if (res.result) {
                    this.$myMsg.notify({
                        title: '恢复成功！',
                        content: '背景已恢复为默认',
                        type: 'success',
                        time: 3000,
                    })
                }
            })
        }
    }
}
</script>
